import lazyLoading from "./lazyLoading";

export default {
  name: "inventar",
  meta: {
    expanded: false,
    title: "Inventar",
    class: "danger",
    show: true,
    iconClass: "fa fa-italic"
  },

  children: [
    {
      name: "inventar-ulaz",
      path: "/inventar/ulaz",
      component: lazyLoading("inventar/ulaz/ulaz"),
      meta: {
        title: "Ulaz",
        requiredAuth: true
      }
    },
    {
      name: "inventar-izlaz",
      path: "/inventar/izlaz",
      component: lazyLoading("inventar/izlaz/izlaz"),
      meta: {
        title: "Izlaz",
        requiredAuth: true
      }
    },
    {
      name: "inventar-stanje",
      path: "/inventar/stanje",
      component: lazyLoading("inventar/stanje/pregled"),
      meta: {
        title: "Stanje",
        requiredAuth: true
      }
    },
    {
      name: "inventar-produkti",
      path: "/inventar/produkti",
      component: lazyLoading("inventar/produkti/pregled"),
      meta: {
        title: "Produkti",
        requiredAuth: true
      }
    },
    {
      name: "inventar-postavke",
      path: "/inventar/postavke",
      component: lazyLoading("inventar/postavke/postavke"),
      meta: {
        title: "Postavke",
        requiredAuth: true
      },  
    },

  ]
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/inventar.js